<template>
  <div class="mb-4">
    <h6 class="text-uppercase font-weight-bold text-secondary mb-3">
      <i class="fas fa-history mr-1"></i> Previously Generated Reports
    </h6>

    <!-- Empty State -->
    <div v-if="!history || history.length === 0"
         class="text-muted text-center py-4 border rounded bg-light">
      <i class="fas fa-file-times fa-2x mb-2 d-block"></i>
      No reports have been generated for this incident yet.<br>
      <small>Generate your first report using the button above.</small>
    </div>

    <!-- History Table -->
    <b-table-simple v-else responsive bordered small class="rg-table mb-0">
      <b-thead class="bg-light">
        <b-tr>
          <b-th>Version</b-th>
          <b-th>Generated</b-th>
          <b-th>Generated By</b-th>
          <b-th class="text-center">Actions</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="item in sortedHistory" :key="item.versionNumber || item.id">
          <b-td>
            <b-badge variant="secondary" pill>v{{ item.versionNumber }}</b-badge>
          </b-td>
          <b-td class="text-nowrap">
            {{ item.generatedAtUtc | formatDate }}
          </b-td>
          <b-td>{{ item.requestedByName || '—' }}</b-td>
          <b-td class="text-center" style="white-space: nowrap;">
            <b-button
              v-if="item.publicShareUrl"
              size="sm"
              variant="outline-primary"
              :disabled="downloadingId === item.id"
              class="mr-1"
              @click="handleDownload(item)"
            >
              <span v-if="downloadingId === item.id">
                <b-spinner small class="mr-1"></b-spinner>Downloading...
              </span>
              <span v-else>
                <i class="fas fa-download mr-1"></i>Download
              </span>
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="$emit('regenerate', item)"
            >
              <i class="fas fa-redo mr-1"></i>Regenerate
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'IncidentReportHistoryTable',
  props: {
    history: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      downloadingId: null
    }
  },
  computed: {
    sortedHistory () {
      if (!this.history) return []
      return [...this.history].sort((a, b) => (b.versionNumber || 0) - (a.versionNumber || 0))
    }
  },
  methods: {
    async handleDownload (item) {
      if (this.downloadingId) return
      this.downloadingId = item.id
      try {
        const response = await fetch(item.publicShareUrl)
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `Incident-Report-v${item.versionNumber}.pdf`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (err) {
        console.error('Download failed', err)
      } finally {
        this.downloadingId = null
      }
    }
  }
}
</script>
